import React, { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import {generate_token, projectEmail, projectName, projectPhone} from "../../url";
import {projectAddress} from "../../resources/constants";

// Dummy currency converter function
const currencyConverter = (value) => `₦${Number(value).toLocaleString()}`;

const HospitalInvoice = ({ serviceList, roomList, appointmentList, imagingList, labList, prescriptionList }) => {

    const appointment_total = appointmentList.reduce((acc, service) => acc + service.appointmentAmount, 0);
    const room_total = roomList.reduce((acc, service) => acc + service.incurredAmount, 0);
    const prescription_total = prescriptionList.reduce((acc, service) => acc + service.drugTotalAmount, 0);
    const imaging_total = imagingList.reduce((acc, service) => acc + service.price, 0);
    const lab_total = labList.reduce((acc, service) => acc + service.testAmount, 0);
    const service_total = serviceList.reduce((acc, service) => acc + service.itemTotal, 0);

    const total_payable = appointment_total + room_total + prescription_total + imaging_total + lab_total + service_total;

    const printRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => printRef.current,
    });

    return (
        <>
            <button className="btn btn-primary float-right" onClick={handlePrint}>
                Print Invoice
            </button>

            <div
                ref={printRef}
                className="invoice-print"
                style={{ display: "none" }} // Hidden by default, visible only on print
            >
                <div className="container" style={{ padding: "20px", color: "#000" }}>
                    <div className="mb-5" style={{fontSize: '20px'}}>
                        <center><img src={require('../../../images/enyimba-black.png')} className=" mt-2  mb-3 text-center" width="400" height="150"/></center>
                        {/*<h3 align="center" style={{fontWeight: 'bold', fontSize: '35px'}}> {projectName} </h3>*/}
                        <h5 align="center" style={{fontWeight: 'bold'}}> {projectAddress}</h5>
                        <h5 align="center" style={{fontWeight: 'bold'}}>{projectEmail}</h5>
                        <h5 align="center" style={{fontWeight: 'bold'}}>Tel: {projectPhone}
                        </h5>
                        <p align="center" className="mb-2" style={{fontWeight: 'bold'}}><i><u> Payment Invoice</u></i></p>
                        <hr/>
                    </div>
                    <h3><b>INVOICE</b> <span className="pull-right">#{generate_token(5)}-{generate_token(5)}</span></h3>
                    <hr/>

                    {
                        roomList.length > 0 ?
                            <>
                                <h3>Admission</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Room Name</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {roomList.map((r, count) => (
                                        <tr key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.bedName}</td>
                                            <td style={{padding: '2px'}}>{1}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.incurredAmount)}</td>
                                            <td style={{padding: '2px'}} width={80}>{currencyConverter(r.incurredAmount)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                            : <></>
                    }

                    {
                        appointmentList.length > 0 ?
                            <>
                                <h3>Consultation</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Specialisation</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {appointmentList.map((r, count) => (
                                        <tr key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.appointmentDepartment}</td>
                                            <td style={{padding: '2px'}}>{1}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.appointmentAmount)}</td>
                                            <td style={{padding: '2px'}} style={{padding: '2px'}} width={80}>{currencyConverter(r.appointmentAmount)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                            : <></>
                    }

                    {
                        serviceList.length > 0 ?
                            <>
                                <h3>Service Request</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Service Name</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {serviceList.map((r, count) => (
                                        <tr style={{padding: '2px'}} key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.serviceName}</td>
                                            <td style={{padding: '2px'}}>{r.itemQty}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.itemPrice)}</td>
                                            <td style={{padding: '2px'}} width={80}>{currencyConverter(r.itemTotal)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                        : <></>
                    }

                    {
                        labList.length > 0 ?
                            <>
                                <h3>Lab</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Lab Name</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {labList.map((r, count) => (
                                        <tr key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.testName}</td>
                                            <td style={{padding: '2px'}}>{1}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.testAmount)}</td>
                                            <td style={{padding: '2px'}} width={80}>{currencyConverter(r.testAmount)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                            : <></>
                    }

                    {
                        imagingList.length > 0 ?
                            <>
                                <h3>Imaging</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Imaging Name</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {imagingList.map((r, count) => (
                                        <tr key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.imageName}</td>
                                            <td style={{padding: '2px'}}>{1}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.price)}</td>
                                            <td style={{padding: '2px'}} width={80}>{currencyConverter(r.price)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                            : <></>
                    }

                    {
                        prescriptionList.length > 0 ?
                            <>
                                <h3>Pharmacy</h3>
                                <table
                                    className="table table-bordered"
                                    cellSpacing={1}
                                    style={{ width: "100%", borderCollapse: "collapse", fontSize: '13px'}}
                                >
                                    <thead style={{ backgroundColor: "#f5f5f5" }}>
                                    <tr>
                                        <th>#</th>
                                        <th>Item Name</th>
                                        <th>Qty</th>
                                        <th>Unit Price</th>
                                        <th>Total</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {prescriptionList.map((r, count) => (
                                        <tr key={count}>
                                            <td style={{padding: '2px'}} width={40}>{count + 1}</td>
                                            <td style={{padding: '2px'}}>{r.drugName}</td>
                                            <td style={{padding: '2px'}}>{r.drugQuantity}</td>
                                            <td style={{padding: '2px'}}>{currencyConverter(r.drugAmount)}</td>
                                            <td style={{padding: '2px'}} width={80}>{currencyConverter(r.drugTotalAmount)}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </>
                            : <></>
                    }
                    <table className="table table-bordered">
                       <tbody>
                           <tr>
                               <td width={40}>#</td>
                               <td>--</td>
                               <td>--</td>
                               <td><h4>Total Amount</h4></td>
                               <td width={200}><h4>{currencyConverter(total_payable)}</h4></td>
                           </tr>
                       </tbody>
                    </table>
                </div>
            </div>

            <style>
                {`
        @media print {
          body * {
            visibility: hidden;
          }
          .invoice-print, .invoice-print * {
            visibility: visible;
          }
          .invoice-print {
            display: block !important;
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            background: white;
          }
        }
        `}
            </style>
        </>
    );
};

export default HospitalInvoice;
